/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Metabuildstitle2Inputs */

const id_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const ms_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaan`)
};

const da_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const de_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const en_us2_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const es_es2_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilaciones`)
};

const es_mx2_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilaciones`)
};

const fil_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Build`)
};

const fr_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilations`)
};

const it_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const hu_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build-ek`)
};

const nl_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const no_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const pl_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompilacje`)
};

const pt_br2_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const pt_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilações`)
};

const ro_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilări`)
};

const fi_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koontiversiot`)
};

const sv_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byggen`)
};

const vi_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản dựng`)
};

const tr_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapılar`)
};

const cs_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sestavení`)
};

const bg_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компилации`)
};

const ru_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сборки`)
};

const uk_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Збірки`)
};

const ar_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البنيات`)
};

const hi_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिल्ड`)
};

const th_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บิลด์`)
};

const ja_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビルド`)
};

const zh_cn2_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`构建版本`)
};

const zh_hant1_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建置版本`)
};

const ko_sandboxes_metabuildstitle2 = /** @type {(inputs: Sandboxes_Metabuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빌드`)
};

/**
* | output |
* | --- |
* | "Builds" |
*
* @param {Sandboxes_Metabuildstitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_metabuildstitle2 = /** @type {((inputs?: Sandboxes_Metabuildstitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Metabuildstitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_metabuildstitle2(inputs)
	if (locale === "ms") return ms_sandboxes_metabuildstitle2(inputs)
	if (locale === "da") return da_sandboxes_metabuildstitle2(inputs)
	if (locale === "de") return de_sandboxes_metabuildstitle2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_metabuildstitle2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_metabuildstitle2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_metabuildstitle2(inputs)
	if (locale === "fil") return fil_sandboxes_metabuildstitle2(inputs)
	if (locale === "fr") return fr_sandboxes_metabuildstitle2(inputs)
	if (locale === "it") return it_sandboxes_metabuildstitle2(inputs)
	if (locale === "hu") return hu_sandboxes_metabuildstitle2(inputs)
	if (locale === "nl") return nl_sandboxes_metabuildstitle2(inputs)
	if (locale === "no") return no_sandboxes_metabuildstitle2(inputs)
	if (locale === "pl") return pl_sandboxes_metabuildstitle2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_metabuildstitle2(inputs)
	if (locale === "pt") return pt_sandboxes_metabuildstitle2(inputs)
	if (locale === "ro") return ro_sandboxes_metabuildstitle2(inputs)
	if (locale === "fi") return fi_sandboxes_metabuildstitle2(inputs)
	if (locale === "sv") return sv_sandboxes_metabuildstitle2(inputs)
	if (locale === "vi") return vi_sandboxes_metabuildstitle2(inputs)
	if (locale === "tr") return tr_sandboxes_metabuildstitle2(inputs)
	if (locale === "cs") return cs_sandboxes_metabuildstitle2(inputs)
	if (locale === "bg") return bg_sandboxes_metabuildstitle2(inputs)
	if (locale === "ru") return ru_sandboxes_metabuildstitle2(inputs)
	if (locale === "uk") return uk_sandboxes_metabuildstitle2(inputs)
	if (locale === "ar") return ar_sandboxes_metabuildstitle2(inputs)
	if (locale === "hi") return hi_sandboxes_metabuildstitle2(inputs)
	if (locale === "th") return th_sandboxes_metabuildstitle2(inputs)
	if (locale === "ja") return ja_sandboxes_metabuildstitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_metabuildstitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_metabuildstitle2(inputs)
	return ko_sandboxes_metabuildstitle2(inputs)
});
export { sandboxes_metabuildstitle2 as "sandboxes.metaBuildsTitle" }